export default "__VITE_ASSET__5x_TR14GBrd238lRNBwd1A__"